import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import RouteLoading from '../../components/RouteLoading';
import lookupRegion from '../../../../services/firebase/region';
import { getFirestoreInstance } from '../../../../services/firebase';
import { setRegionData } from '../../../../redux/phio/phioActions';
import { resetStore } from '../../../../redux/phioStore';
import { signOut } from '../../../../services/auth';
import useSetWebUiConfigByClientId from '../../../../redux/webUiConfig/webUiConfigHooks';

export default function RegistrationRegionProvider({
    children,
}: {
    children: JSX.Element;
}) {
    const { providerName } = useParams<{ providerName: string }>();
    const [initialising, setInitialising] = useState(true);
    const dispatch = useDispatch();
    const setWebUiConfigByClientId = useSetWebUiConfigByClientId(dispatch);

    const navigate = useNavigate();

    const { state } = useLocation();

    useEffect(() => {
        if (!providerName) {
            return;
        }

        // sign out and clear patient data
        if (!state?.redirected && !state?.cancelScreeningJourney) {
            signOut().then(() => {
                resetStore();
                setWebUiConfigByClientId(null);
            });
        }

        lookupRegion(providerName)
            .then(({ data }) => {
                if (data.status !== 200 || !data.validated) {
                    navigate('/', { replace: true });
                    return;
                }

                getFirestoreInstance(data.database_id); // Initialise Firestore if first call
                dispatch(
                    setRegionData({
                        databaseId: data.database_id,
                        region: data.region,
                    }),
                );
                setInitialising(false);
            })
            .catch((e: Error) => {
                console.log('error', e);
                navigate('/', { replace: true });
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        providerName,
        setWebUiConfigByClientId,
        state?.cancelScreeningJourney,
        state?.redirected,
    ]);

    return initialising ? <RouteLoading /> : children;
}
